import { render, staticRenderFns } from "./nomenclatures.vue?vue&type=template&id=5dfba112&"
import script from "./nomenclatures.vue?vue&type=script&lang=js&"
export * from "./nomenclatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports